<template>
    <Navbar></Navbar>
    <div class="content-wrapper mt-15">
        <div class="main-content pt-90 lg:pt-60">
            <FaqHeader />
           <div class="container pt-40 pb-60 mt-40">
            <Questions />
           </div>
        </div>
        <FooterItem />
    </div>
</template>

<script>
import Navbar from "@/components/Layout/Navbar.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import FaqHeader from "@/components/common/FaqHeader.vue";
import Questions from "@/components/CourseDetails/Questions.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import store from "@/store";
export default {
    components: {
        Navbar,
        Questions,
        FaqHeader,
        FooterItem,
    },
    computed: {
        ...mapGetters(["currentLanguage"]),
    },
    methods: {
        updateHeadMeta() {
            const title =
                this.currentLanguage === "ar"
                    ? "الأسئلة الشائعة - Planning Force | نحن هنا للمساعدة"
                    : "FAQ - Planning Force | We Are Here to Help";

            const description =
                this.currentLanguage === "ar"
                    ? "اقرأ الأسئلة المتكررة للإجابة على استفساراتك حول خدماتنا. نحن هنا للمساعدة!"
                    : "Check out the frequently asked questions to get answers to your queries about our services. We're here to help!";

            const keywords =
                this.currentLanguage === "ar"
                    ? "الأسئلة الشائعة, دعم, استفسارات, Planning Force, التعليم الإلكتروني"
                    : "faq, support, inquiries, Planning Force, e-learning";

            useHead({
                title: title,
                meta: [
                    { name: "description", content: description },
                    { name: "keywords", content: keywords },
                    { name: "robots", content: "index, follow" },
                    {
                        name: "author",
                        content:
                            this.currentLanguage === "ar"
                                ? "معهد Planning Force العالي للتدريب"
                                : "Planning Force High Institute for Training",
                    },
                    {
                        name: "language",
                        content: this.currentLanguage === "ar" ? "ar" : "en",
                    },

                    // Open Graph meta tags
                    { property: "og:title", content: title },
                    { property: "og:description", content: description },
                    {
                        property: "og:image",
                        content: "https://example.com/faq-og-image.jpg", // Replace with your FAQ page image URL
                    },
                    { property: "og:url", content: "https://example.com/faq" }, // Replace with your FAQ page URL
                    { property: "og:type", content: "website" },

                    // Twitter Card meta tags
                    { name: "twitter:card", content: "summary_large_image" },
                    { name: "twitter:title", content: title },
                    { name: "twitter:description", content: description },
                    {
                        name: "twitter:image",
                        content: "https://example.com/faq-twitter-image.jpg", // Replace with your FAQ page image URL
                    },
                ],
            });
        },

    },
    mounted() {
       // this.updateHeadMeta();
    },
    watch: {
        currentLanguage: {
            handler(newLang, oldLang) {
                //  this.language = newLang;
                this.updateHeadMeta();
                store.dispatch("categoriesList");
            },
            immediate: true, // Run the handler immediately when the component is mounted
        },
    },
};
</script>